export const TestIds = {
  layout: 'chat-layout',
  bottomSection: 'chat-layout-bottom-section',
  welcomeSection: 'chat-layout-welcome-section',
};
